{
    "longSHA": "97c7247788b074db8eee790b49eaeb251c32cd6f",
    "shortSHA": "97c7247",
    "branch": "development",
    "authorName": "Damjan Tonkli",
    "commitTime": "Tue Dec 16 16:04:00 2025 +0100",
    "commitMsg": "fix(offer): a few fixes and seeder data",
    "totalCommitCount": "1"
}